import Component from '../abstracts/Component';

export default class FormStylingComponent extends Component {

  get CLASSES() {
    return {
      hasValue: 'has-value',
    };
  }

  constructor() {
    super();
  }

  bindEvents() {
    this.observeAddedFields();
    this.markFieldOnChanges();
  }

  markFieldsWithValue(fields) {
    if (!fields) {
      fields = this.getFields(document.body);
    }
    let ctx = this;
    if (!fields) {
      return;
    }
    fields.each(function() {
      let field = $(this)[0];
      ctx.markIfHasValue(field);
    });
  }

  markFieldOnChanges() {
    let ctx = this;
      $(document).change(function(eventObject) {
        ctx.markIfHasValue(eventObject.target);
      });
  }

  markIfHasValue(field) {
    if (!field.classList) {
      return;
    }
    if (field.value) {
      field.classList.add(this.CLASSES.hasValue);
    } else {
      field.classList.remove(this.CLASSES.hasValue);
    }
  }

  observeAddedFields() {
    const config = { attributes: false, childList: true, subtree: true };
    const ctx = this;
    const callback = function(mutationsList) {
      for(const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          let addedNodes = mutation.addedNodes;
          for (const addedNode of addedNodes) {
            let fields = ctx.getFields(addedNode);
            ctx.markFieldsWithValue(fields);
          }
        }
      }
    };

    const observer = new MutationObserver(callback);

    observer.observe(document.body, config);
  }

  getFields(node) {
    return $(node).find('input, select, textarea');
  }

  render() {
    this.bindEvents();
    this.markFieldsWithValue();
    console.info('[FormStyling] init');
  }


}
